import { captureException } from "@sentry/react";
let imagesPath = require.context('../assets/images', true);

export default imagesPath;

export const getImagesPath = (imageName) => {
    let image = null;
    try{
        image= imagesPath(`./${imageName}`)
    } catch(e){
        captureException(new Error(`Image ${imageName} have not been found. ${e}`));
    } finally {
        return image;
    }
}

export const isImageUrl = (imagePathToCheck) => {
    return (imagePathToCheck && (imagePathToCheck.startsWith('http://') || imagePathToCheck.startsWith('https://')))
};

export const getImageSource = (imagePathOrName) => {
    if (isImageUrl(imagePathOrName))
        return imagePathOrName;
    if (imagePathOrName)
        return getImagesPath(imagePathOrName);
    return null;
}